import $ from 'jquery';
import _ from 'lodash';
import { api } from './api';
import { userinfo } from './userinfo';
import { util } from './util';
import { ui } from './ui';
import { drawing } from './drawing';
import { DropdownToolList } from './DropDownToolList';

import { API } from '../../utilities/constants';
import { headReplace } from '../../utilities/stringUtil';
import { isPartnerCompany } from '../../utilities/roleUtility';
import { fileSizeCheck, fileTypeCheck } from '../../utilities/fileType';
import { messageUtility } from '../../utilities/messageUtility';

function _parts() {
  this._scale = 100;
  this.groupItems = {};
  // 初期化
  this.init = function() {
    var self = this;
    self.reloadPartsGroup();
  };

  // 部品グループ再読込
  this.reloadPartsGroup = async function() {
    var self = this;
    const partsGroupRes = await api.getPartsGroup();
    var partsGroupList =
      partsGroupRes.data.entities.construction_placement_part_groups;
    self.setPartsGroupList(partsGroupList);
    for (let i in partsGroupList) {
      this.groupItems[partsGroupList[i].id] = partsGroupList[i];
    }
  };

  // 部品グループ再読込を SignalR で他ブラウザに通知する
  this.reloadPartsGroupSignalrSync = function() {
    drawing.client.dataPublish('menuReloadPartsGroup', {});
  };

  // jQueryイベントを off on して再設定する
  this.jqEventReset = function(jqObject, eventName, eventFunc) {
    jqObject.off(eventName).on(eventName, eventFunc);
  };

  // 部品グループリスト更新
  this.setPartsGroupList = function(groupList) {
    var self = this;
    var groupListItem =
      '' +
      '<li class="dropdown-tool-list__item parts_group_list_item group-%%group_id%%">' +
      '</li>';
    var prisetGroup =
      '<div class="tool-list-btn"><p class="tool-table__filename group-name">%%group%%</p></div>';
    var editableGroup;
    if (isPartnerCompany(userinfo.getUserType())) {
      editableGroup =
        '' +
        '<div class="tool-list-btn tool-list-edit">' +
        '<p class="tool-list-edit__text">%%group%%</p>' +
        '<div />' +
        '</div>';
    } else {
      editableGroup = `<div class="tool-list-btn tool-list-edit">
          <p class="tool-table__filename group-name group_name_%%group_id%%" data-groupid="%%group_id%%" data-group-name="%%group%%">%%group%%</p>
        </div>`;
    }

    self.$partsGroupDropdownList = $('.parts_group_dropdown .parts_group_list');

    self.$partsGroupDropdownList.html('');
    _.each(groupList, function(group) {
      var groupId = group.id;
      var groupName = group.name;
      // var editable = group.editable;
      // 協力会社ユーザーの場合グループ編集不可能
      var editable =
        group.company_branch_id !== null &&
        !isPartnerCompany(userinfo.getUserType());

      var addGroupListItem = groupListItem.replace('%%group_id%%', groupId);
      self.$partsGroupDropdownList.append(addGroupListItem);
      if (!editable) {
        var addPrisetGroup = prisetGroup.replace(
          '%%group%%',
          _.escape(groupName)
        );
        $(`.parts_group_list_item.group-${groupId}`).append(addPrisetGroup);
      } else {
        var addEditableGroup = editableGroup
          .replace('%%group%%', _.escape(groupName))
          .replace('%%group%%', _.escape(groupName))
          .replace('%%group_id%%', groupId)
          .replace('%%group_id%%', groupId);
        $(`.parts_group_list_item.group-${groupId}`).append(addEditableGroup);
      }
      self.reloadParts(groupId, editable);
    });
    if (!isPartnerCompany(userinfo.getUserType())) {
      self.$partsGroupDropdownList.append(
        '<li class="dropdown-tool-list__item sys_add_parts_group">' +
          "                  <i class='add-group-icon btn-icon i-3x' alt='ズーム+'>\n" +
          '                    <svg\n' +
          "                      xmlns='http://www.w3.org/2000/svg'\n" +
          "                      height='24'\n" +
          "                      viewBox='0 0 24 24'\n" +
          "                      width='24'\n" +
          '                    >\n' +
          "                      <path d='M0 0h24v24H0V0z' fill='none' />\n" +
          "                      <path d='M18 13h-5v5c0 .55-.45 1-1 1s-1-.45-1-1v-5H6c-.55 0-1-.45-1-1s.45-1 1-1h5V6c0-.55.45-1 1-1s1 .45 1 1v5h5c.55 0 1 .45 1 1s-.45 1-1 1z' />\n" +
          '                    </svg>\n' +
          '                  </i>\n' +
          '<p class="add-group-text">グループの追加</p></li>'
      );
    }

    self.$modalDialogAddPartsGroup = $('#modal-dialog-add-parts-group');
    self.$modalDialogEditPartsGroup = $('#modal-dialog-edit-parts-group');
    self.$modalDialogDeletePartsGroup = $('#modal-dialog-delete-parts-group');

    // 部品グループ +追加
    self.jqEventReset($('.sys_add_parts_group'), 'click', function() {
      $('.tool-crane, .tool-crane__dropdown').removeClass('selected');
      self.$modalDialogAddPartsGroup.find('[name=group_name]').val('');
      self.$modalDialogAddPartsGroup.addClass('show');
    });

    // 部品グループ追加画面 戻る
    self.jqEventReset(
      self.$modalDialogAddPartsGroup.find('.sys_cancel'),
      'click',
      function() {
        self.$modalDialogAddPartsGroup.removeClass('show');
      }
    );

    // 部品グループ追加画面 追加する
    self.jqEventReset(
      self.$modalDialogAddPartsGroup.find('.sys_submit'),
      'click',
      function() {
        var uuid = util.getUuid();
        var name = self.$modalDialogAddPartsGroup
          .find('[name=group_name]')
          .val();
        var grp = {
          id: uuid,
          name,
        };
        parts.addGroup(grp);
        self.$modalDialogAddPartsGroup.removeClass('show');
      }
    );

    // 部品グループ編集画面 戻る
    self.jqEventReset(
      self.$modalDialogEditPartsGroup.find('.sys_cancel'),
      'click',
      function() {
        self.$modalDialogEditPartsGroup.removeClass('show');
      }
    );

    // 部品グループ編集画面 削除
    self.jqEventReset(
      self.$modalDialogEditPartsGroup.find('.sys_delete'),
      'click',
      function() {
        var name = self.$modalDialogEditPartsGroup
          .find('[name=group_name]')
          .val();
        self.$modalDialogDeletePartsGroup.find('[name=group_name]').text(name);

        self.$modalDialogEditPartsGroup.removeClass('show');
        self.$modalDialogDeletePartsGroup.addClass('show');
        // 部品グループ削除確認画面の表示
      }
    );

    // 部品グループ編集画面 更新
    self.jqEventReset(
      self.$modalDialogEditPartsGroup.find('.sys_submit'),
      'click',
      function() {
        var groupId = self.$modalDialogEditPartsGroup
          .find('[name=group_id]')
          .val();
        var name = self.$modalDialogEditPartsGroup
          .find('[name=group_name]')
          .val();
        var grp = {
          name,
        };
        parts.editGroup(groupId, grp);
        self.$modalDialogEditPartsGroup.removeClass('show');
      }
    );

    // 部品グループ削除確認画面 戻る
    self.jqEventReset(
      self.$modalDialogDeletePartsGroup.find('.sys_cancel'),
      'click',
      function() {
        self.$modalDialogDeletePartsGroup.removeClass('show');
      }
    );

    // 部品グループ削除確認画面 削除
    self.jqEventReset(
      self.$modalDialogDeletePartsGroup.find('.sys_delete'),
      'click',
      function() {
        var groupId = self.$modalDialogEditPartsGroup
          .find('[name=group_id]')
          .val();
        // groupId は、部品グループ編集画面に保持している値を使用する
        parts.deleteGroup(groupId);
        self.$modalDialogDeletePartsGroup.removeClass('show');
      }
    );

    // 部品グループ メニュー項目
    self.$partsGroupListItem = $('.parts_group_list_item');
    self.$notPartsToolTable = $('html:not(.tool-table .tool-table__body)');
    self.$addPartGroup = $('.sys_add_parts_group');
    self.jqEventReset(self.$partsGroupListItem, 'mouseenter', function() {
      self.$partsGroupListItem.removeClass('selected');
      $(this).addClass('selected');
      const numberOfRows = $(this).find('tr').length || 0;
      // table parts will be broken on IE when vertical scroolbar appears
      if (numberOfRows >= 3 && ui.isIE()) {
        $('.tool-table .tool-table__body').css({
          width: '385px',
        });
      } else {
        $('.tool-table .tool-table__body').css({
          width: '375px',
        });
      }
    });
    self.jqEventReset(self.$addPartGroup, 'mouseenter', function() {
      self.$partsGroupListItem.removeClass('selected');
    });
    self.jqEventReset(self.$notPartsToolTable, 'click', function() {
      self.$partsGroupListItem.removeClass('selected');
    });
  };

  // 部品グループ内 部品 更新
  this.reloadParts = async function(partsGroupId, editable) {
    var self = this;
    const partsRes = await api.getParts(partsGroupId);
    var partsList = partsRes.data.entities.construction_placement_parts;
    self.setPartsList(partsGroupId, partsList, editable);
  };

  // 部品 更新 を SignalR で他ブラウザに通知する
  // eslint-disable-next-line no-unused-vars
  this.reloadPartsSignalrSync = function(partsGroupId) {
    drawing.client.dataPublish('menuReloadParts', {
      partsGroupId,
    });
  };

  // 部品 更新
  this.setPartsList = function(groupId, partsList, editable) {
    var self = this;
    var partsGrid;
    if (isPartnerCompany(userinfo.getUserType())) {
      partsGrid =
        '' +
        '<div class="dropdown-tool-list__child tool-crane__grid parts-grid">' +
        '<div class="tool-table">' +
        '<div class="tool-table__body">' +
        '<table class="tool-table__table parts-table"></table>' +
        '</div>' +
        '</div>' +
        '</div>';
    } else {
      partsGrid =
        `${'' +
          '<div class="dropdown-tool-list__child tool-crane__grid parts-grid">' +
          '<div class="tool-table">' +
          '<div class="tool-table__header">'}${
          editable && groupId
            ? `<p class="tool-list-edit__text parts_group_edit btn-text--sm" style="width: 100%" data-groupid=${groupId}>${_.escape(
                this.groupItems[groupId].name
              )}</p>`
            : `<p class="tool-list-normal__text">${_.escape(
                this.groupItems[groupId].name
              )}</p>`
        }<div class="tool-table-menu">` +
        `<div class="tool-table-menu__item parts-menu-%%group_id%%">` +
        `<div class="tool-table-menu__label select-parts-scale">` +
        `<span class="label">貼付倍率</span>` +
        `</div>` +
        `<div class="tool-table-menu__element select-parts-scale">` +
        `</div>` +
        `</div>` +
        `</div>` +
        `</div>` +
        `<div class="tool-table__body">` +
        `<table class="tool-table__table parts-table">` +
        `</table>` +
        `</div>` +
        `</div>` +
        `</div>`;
    }

    // 部品 追加 ボタン
    var addPartsButton =
      '' +
      '<div class="tool-table-menu__item">' +
      '<label for="parts_%%group_id%%" class="btn-parts-add sys_parts_add">' +
      'アイテムの追加' +
      '<input id="parts_%%group_id%%" name="parts_%%group_id%%" type="file">' +
      '</label>' +
      '</div>';

    var partsTr = '' + '<tr class="tool-table__row parts-row">' + '</tr>';

    var partsTd =
      '' +
      '<td class="tool-table__item parts-%%parts_id%%">' +
      '<div class="parts">' +
      '<img src="%%src%%" alt="%%parts_alt%%">' +
      '<div class="parts__title parts__tooltip" data-label="%%parts_tooltip%%">%%parts_name%%</div>' +
      '</div>' +
      '</td>';

    // 部品アイコン と 部品名リンク
    var editablePartsTd =
      '' +
      '<td class="tool-table__item parts-%%parts_id%%">' +
      '<div class="parts">' +
      '<img src="%%src%%" alt="%%parts_alt%%">' +
      '<div class="parts__title">' +
      '<button class="btn-text--sm tool-table__filename sys_parts_edit_%%parts_id%% parts__tooltip" data-label="%%parts_tooltip%%">%%parts_name%%</button>' +
      '</div>' +
      '</div>' +
      '</td>';

    var addPartsGrid = partsGrid.replace('%%group_id%%', groupId);

    $(`.group-${groupId} .parts-grid`).remove();
    $(`.group-${groupId}`).append(addPartsGrid);
    self.addScaleList(
      $(`.parts-menu-${groupId} .select-parts-scale:last`),
      groupId
    );
    //ユーザ種別が職長の場合、貼付倍率を非表示にする
    if (isPartnerCompany(userinfo.getUserType())) {
      $('.select-parts-scale').hide();
    }
    if (editable) {
      // 部品追加ボタン への情報追記
      var addAddPartsButton = addPartsButton
        .replace('%%group_id%%', groupId)
        .replace('%%group_id%%', groupId)
        .replace('%%group_id%%', groupId);
      $(`.parts-menu-${groupId}`)
        .closest('.tool-table-menu')
        .append(addAddPartsButton);

      // 部品追加時の ファイル選択ダイアログ でのファイル選択後のイベント
      $(`[name=parts_${groupId}]`).change(async function() {
        // ファイル名を取得
        var file = $(`[name=parts_${groupId}]`).prop('files')[0];
        $('.tool-crane, .tool-crane__dropdown').removeClass('selected');
        if (!file) {
          return;
        }
        $(`[name=parts_${groupId}]`).replaceWith(
          $(`[name=parts_${groupId}]`).clone(true)
        );

        if (!(await fileTypeCheck(file))) {
          // メッセージ内容
          //  選択可能な画像形式は「JPEG、GIF、PNG」ファイルです
          ui.showPopupMessage(messageUtility.getMessage('E-000-012'));
          $(`[name=parts_${groupId}]`).val('');
          return;
        }

        // 15MB以上はエラー
        if (!(await fileSizeCheck(file))) {
          // メッセージ内容
          //  ファイルアップロードの上限は15MBです。
          //  15MB以下の画像を選択してください。
          ui.showPopupMessage(messageUtility.getMessage('E-000-011'));
          $(`[name=parts_${groupId}]`).val('');
          return;
        }

        //インジケータ表示
        ui.showLoaderBg('');

        self.addParts(groupId, file);
      });
    }

    var tdList = [];
    _.each(partsList, function(parts) {
      // 部品アイコン と 部品名リンク への情報追記
      var tmpPartsId = editable ? editablePartsTd : partsTd;
      let imagePath = parts.image_path;
      imagePath = headReplace(imagePath, '/share/', `${API.nfs}/`);
      imagePath = headReplace(imagePath, '/canvas/', `${API.nfs}/canvas/`);
      var addPartsTd = tmpPartsId
        .replace('%%parts_id%%', parts.id)
        .replace('%%src%%', imagePath)
        .replace('%%parts_id%%', parts.id)
        .replace('%%parts_alt%%', _.escape(parts.name))
        .replace('%%parts_tooltip%%', _.escape(parts.name))
        .replace('%%parts_name%%', _.escape(parts.name));
      tdList.push(addPartsTd);
      if (tdList.length >= 3) {
        addPartsTd = _.map(tdList, function(td) {
          return td;
        });
        $(`.group-${groupId} .parts-table`).append(partsTr);
        $(`.group-${groupId} .parts-table .parts-row:last`).append(addPartsTd);
        tdList = [];
      }
    });
    if (partsList.length === 2) {
      let emptyTdPart =
        '<td class="tool-table__item tool-table__item--empty"/' + '>';
      tdList.push(emptyTdPart);
    }
    if (tdList.length > 0) {
      var addPartsTd = _.map(tdList, function(td) {
        return td;
      });
      $(`.group-${groupId} .parts-table`).append(partsTr);
      $(`.group-${groupId} .parts-table .parts-row:last`).append(addPartsTd);
    }
    // 協力会社ユーザーで部品がない場合リストから非表示
    if (isPartnerCompany(userinfo.getUserType()) && partsList.length === 0) {
      $(`.group-${groupId}`).remove();
    }

    self.$modalDialogAddParts = $('#modal-dialog-add-parts');
    _.each(partsList, function(parts) {
      // 部品名 リンク クリック イベント の定義
      self.jqEventReset($(`.sys_parts_edit_${parts.id}`), 'click', function() {
        // イベント定義時に 部品編集 ダイアログ に情報を埋め込む
        self.$modalDialogAddParts.find('[name=group_id]').val(groupId);
        self.$modalDialogAddParts.find('[name=parts_id]').val(parts.id);
        self.$modalDialogAddParts.find('[name=parts_name]').val(parts.name);

        // 部品編集 ダイアログ が開く
        self.$modalDialogAddParts.addClass('show');
      });
    });

    // 部品編集ダイアログ 戻る ボタン
    self.jqEventReset(
      self.$modalDialogAddParts.find('.sys_cancel'),
      'click',
      function() {
        self.$modalDialogAddParts.removeClass('show');
      }
    );

    // 部品編集ダイアログ 更新 ボタン
    self.jqEventReset(
      self.$modalDialogAddParts.find('.sys_submit'),
      'click',
      function() {
        var parts = {
          id: self.$modalDialogAddParts.find('[name=parts_id]').val(),
          name: self.$modalDialogAddParts.find('[name=parts_name]').val(),
        };
        self.editParts(
          self.$modalDialogAddParts.find('[name=group_id]').val(),
          parts
        );
        self.$modalDialogAddParts.removeClass('show');
      }
    );

    // 部品編集ダイアログ 削除
    self.jqEventReset(
      self.$modalDialogAddParts.find('.sys_delete'),
      'click',
      function() {
        var id = self.$modalDialogAddParts.find('[name=parts_id]').val();
        self.deleteParts(
          self.$modalDialogAddParts.find('[name=group_id]').val(),
          id
        );
        self.$modalDialogAddParts.removeClass('show');
      }
    );

    // 部品 選択 (部品サムネイル 選択)
    self.jqEventReset($('.parts'), 'click', function() {
      $('.parts').removeClass('selected');
      $(this).addClass('selected');
      $('.tool-crane, .tool-crane__dropdown').removeClass('selected');
      self.partsSelect(this);
    });

    // Edit group handling
    self.jqEventReset($('.parts_group_edit'), 'click', function() {
      var groupId = $(this).attr('data-groupid');
      $('.tool-crane, .tool-crane__dropdown').removeClass('selected');
      var name = $(`.group_name_${groupId}`).text();
      self.$modalDialogAddPartsGroup = $('#modal-dialog-add-parts-group');
      self.$modalDialogEditPartsGroup = $('#modal-dialog-edit-parts-group');
      self.$modalDialogDeletePartsGroup = $('#modal-dialog-delete-parts-group');
      self.$modalDialogEditPartsGroup.find('[name=group_id]').val(groupId);
      self.$modalDialogEditPartsGroup.find('[name=group_name]').val(name);
      self.$modalDialogEditPartsGroup.addClass('show');
    });
  };

  // 部品選択
  this.partsSelect = function(parts) {
    var self = this;
    var scale = drawing.places
      ? parseFloat(drawing.places._scale) * 0.01
      : parseFloat(self._scale) * 0.01;
    drawing._parts_scale = scale;
    drawing._parts_url = $(parts)
      .find('img')
      .attr('src');
    console.log('debug', 'partsSelect', drawing._parts_url);
    ui.toolboxSelect('tool-parts');
  };

  // 部品 新規追加
  this.addParts = async function(groupId, parts) {
    var self = this;
    await api.addParts(groupId, parts);
    await self.reloadParts(groupId, true);
    self.reloadPartsSignalrSync(groupId, true);
    ui.hideLoaderBg('');
  };

  // 部品編集 更新(名前変更)
  this.editParts = async function(groupId, parts) {
    var self = this;
    await api.editParts(parts);
    await self.reloadParts(groupId, true);
    self.reloadPartsSignalrSync(groupId, true);
  };

  // 部品編集 削除
  this.deleteParts = async function(groupId, partsId) {
    var self = this;
    await api.deleteParts(partsId);
    await self.reloadParts(groupId, true);
    self.reloadPartsSignalrSync(groupId, true);
  };

  // 部品グループ新規追加
  this.addGroup = async function(grp) {
    if (grp.name === '') {
      // toastShowMessage('グループ名は空にできません');
      return;
    }
    var self = this;
    await api.addGroup(grp);
    self.reloadPartsGroup();
    self.reloadPartsGroupSignalrSync();
  };

  // 部品グループ修正
  this.editGroup = async function(groupId, grp) {
    var self = this;
    await api.editGroup(groupId, grp);
    self.reloadPartsGroup();
    self.reloadPartsGroupSignalrSync();
  };

  // 部品グループ削除
  this.deleteGroup = async function(groupId) {
    var self = this;
    await api.deleteGroup(groupId);
    self.reloadPartsGroup();
    self.reloadPartsGroupSignalrSync();
  };

  this.addScaleList = function(div, groupId) {
    var self = this;
    var minScale = 10;
    var maxScale = 200;
    var partsScale = drawing.places ? drawing.places._scale : self._scale;
    var partsScaleDropDown =
      `${'' +
        '<div id="dropdown-parts-scale-'}${groupId}" class="tool-item--sm tool-scale-list">` +
      `<div class="tool-item--sm__header">` +
      `<div class="input-spin--sm" alt="貼付倍率">` +
      `<input readonly class="parts_scale" type="text" name="parts_scale_${groupId}" value="${partsScale}%">` +
      `<div class="btn-spin--sm">` +
      `<div class="btn-icon select-up-reverse"><i class="i-2x_2 rotate-to-top"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="black"><path d="M24 24H0V0h24v24z" fill="none" opacity=".87"></path><path d="M15.88 9.29L12 13.17 8.12 9.29c-.39-.39-1.02-.39-1.41 0-.39.39-.39 1.02 0 1.41l4.59 4.59c.39.39 1.02.39 1.41 0l4.59-4.59c.39-.39.39-1.02 0-1.41-.39-.38-1.03-.39-1.42 0z"></path></svg></i></div>` +
      `<div class="dropdown-icon btn-icon select-down-reverse"><i class="i-2x_2 "><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="black"><path d="M24 24H0V0h24v24z" fill="none" opacity=".87"></path><path d="M15.88 9.29L12 13.17 8.12 9.29c-.39-.39-1.02-.39-1.41 0-.39.39-.39 1.02 0 1.41l4.59 4.59c.39.39 1.02.39 1.41 0l4.59-4.59c.39-.39.39-1.02 0-1.41-.39-.38-1.03-.39-1.42 0z"></path></svg></i></div>` +
      `</div>` +
      `</div>` +
      `</div>` +
      `<div class="tool-item--sm__body">` +
      `<ul class="dropdown-tool-list">` +
      `</ul>` +
      `</div>` +
      `</div>`;
    $(div).append(partsScaleDropDown);
    for (var scale = maxScale; scale >= minScale; scale -= 5) {
      partsScale =
        `${'' +
          '<li class="dropdown-tool-list__item">' +
          '<button class="tool-list-btn" data-value="'}${scale}%">${scale}%</button>` +
        `</li>`;
      $(div)
        .find('.dropdown-tool-list')
        .append(partsScale);
    }

    var dropdown = new DropdownToolList();
    dropdown.init(`dropdown-parts-scale-${groupId}`, function(val, on_change) {
      $(this.input).val(`${String(val).replace('%', '')}%`);
      if (on_change) {
        self.updatePartsScale(val);
        if (drawing.places) {
          drawing.places._scale = String(val).replace('%', '');
          try {
            drawing.places.changeScale();
            drawing.client.dataPublish('menuReloadPartsScale', {
              scale: drawing.places._scale,
            });
          } catch (e) {
            console.error('change parts scale error!', e);
          }
        } else {
          self._scale = String(val).replace('%', '');
        }
      }
    });
  };

  this.updatePartsScale = function(scale) {
    $('.parts_scale').val(`${String(scale).replace('%', '')}%`);
    if (drawing.places) {
      drawing.places._scale = scale;
    }
  };
}

export const parts = new _parts();



// WEBPACK FOOTER //
// ./src/canvas/common/parts.js